import React, { useState, useEffect } from "react";
import classnames from "classnames";
import BackgroundVideo from "../components/Background-Video";
import BackButton from "../partials/Back-Button";
import { motion } from "framer-motion";
import Videos from "../video/101160_SCS_Interactive_Sc6_4K_10s_V3.mp4";

const EdgeLogisitcs = () => {
  const [activeDot, setActiveDot] = useState("");
  const [dotOneX, setDotOneX] = useState();
  const [dotOneY, setDotOneY] = useState();
  const [blobOneX, setBlobOneX] = useState();
  const [blobOneY, setBlobOneY] = useState();
  const [dotTwoX, setDotTwoX] = useState();
  const [dotTwoY, setDotTwoY] = useState();
  const [blobTwoX, setBlobTwoX] = useState();
  const [blobTwoY, setBlobTwoY] = useState();
  const [dotThreeX, setDotThreeX] = useState();
  const [dotThreeY, setDotThreeY] = useState();
  const [blobThreeX, setBlobThreeX] = useState();
  const [blobThreeY, setBlobThreeY] = useState();
  const [dotFourX, setDotFourX] = useState();
  const [dotFourY, setDotFourY] = useState();
  const [blobFourX, setBlobFourX] = useState();
  const [blobFourY, setBlobFourY] = useState();

  const getPosition = () => {
    const dotOne = document.getElementById("dotOne").getBoundingClientRect();
    const dotOneTop = dotOne.top;
    const dotOneLeft = dotOne.left;

    setDotOneX(dotOneLeft + 21.5);
    setDotOneY(dotOneTop + 21.5);

    const blobOne = document.getElementById("blobOne").getBoundingClientRect();
    const blobOneTop = blobOne.top;
    const blobOneLeft = blobOne.left;

    setBlobOneX(blobOneLeft);
    setBlobOneY(blobOneTop);

    const dotTwo = document.getElementById("dotTwo").getBoundingClientRect();
    const dotTwoTop = dotTwo.top;
    const dotTwoLeft = dotTwo.left;

    setDotTwoX(dotTwoLeft + 21.5);
    setDotTwoY(dotTwoTop + 21.5);

    const blobTwo = document.getElementById("blobTwo").getBoundingClientRect();
    const blobTwoTop = blobTwo.top;
    const blobTwoLeft = blobTwo.left;

    setBlobTwoX(blobTwoLeft);
    setBlobTwoY(blobTwoTop);

    const dotThree = document
        .getElementById("dotThree")
        .getBoundingClientRect();
    const dotThreeTop = dotThree.top;
    const dotThreeLeft = dotThree.left;

    setDotThreeX(dotThreeLeft + 21.5);
    setDotThreeY(dotThreeTop + 21.5);

    const blobThree = document
        .getElementById("blobThree")
        .getBoundingClientRect();
    const blobThreeTop = blobThree.top;
    const blobThreeLeft = blobThree.left;

    setBlobThreeX(blobThreeLeft);
    setBlobThreeY(blobThreeTop);

    const dotFour = document.getElementById("dotFour").getBoundingClientRect();
    const dotFourTop = dotFour.top;
    const dotFourLeft = dotFour.left;

    setDotFourX(dotFourLeft + 21.5);
    setDotFourY(dotFourTop + 21.5);

    const blobFour = document
        .getElementById("blobFour")
        .getBoundingClientRect();
    const blobFourTop = blobFour.top;
    const blobFourLeft = blobFour.left;

    setBlobFourX(blobFourLeft);
    setBlobFourY(blobFourTop);
  };

  useEffect(() => {
    getPosition();
  }, []);

  return (
      <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="w-screen h-[calc(100vh-120px)] 2xl:h-[calc(100vh-172px)] relative top-[120px] 2xl:top-[172px] left-0"
      >
        <BackButton backurl="/edge-compute" />
        <BackgroundVideo fullscreen video={Videos} />
        <div className="w-screen h-[calc(100vh-120px)] 2xl:h-[calc(100vh-172px)] relative ">
          <div className=" bg-opacity-50 backdrop-blur-md bg-white w-[543px] 2xl:w-[823px] py-7 px-9 2xl:py-14 2xl:px-[59px] rounded-3xl relative right-10 top-5 ml-auto zoom-8">
            <h1 className="font-semibold uppercase text-dell-blue font-proxima-nova text-lg 2xl:text-[25px] 2xl:leading-[30px] pb-3">
              Logistics
            </h1>
            <p className=" text-[#444444] text-xl 2xl:text-[30px] 2xl:leading-[37px] font-proxima-nova font-thin">
              Monetize your 5G investment and grow your managed services business
              by helping to reduce costs and improve management for
              logistics customers.
            </p>
          </div>

          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 1 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <line
                x1={dotOneX}
                y1={dotOneY}
                x2={blobOneX}
                y2={blobOneY}
                stroke="#444444"
                strokeDasharray="15 15"
            />
          </svg>

          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 2 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <line
                x1={dotTwoX}
                y1={dotTwoY}
                x2={blobTwoX}
                y2={blobTwoY}
                stroke="#444444"
                strokeDasharray="15 15"
            />
          </svg>

          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 3 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <line
                x1={dotThreeX}
                y1={dotThreeY}
                x2={blobThreeX}
                y2={blobThreeY}
                stroke="#444444"
                strokeDasharray="15 15"
            />
          </svg>

          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 4 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <line
                x1={dotFourX}
                y1={dotFourY}
                x2={blobFourX}
                y2={blobFourY}
                stroke="#444444"
                strokeDasharray="15 15"
            />
          </svg>

          <div className="edge-dots absolute w-screen h-[calc(100vh-172px)] top-0 grid grid-cols-5 grid-rows-3">
            <div></div>
            <div className="relative flex justify-center items-end">
              <div
                  id="dotOne"
                  className="dot absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] left-6 bg-[#444444] border-2 cursor-pointer"
                  onMouseEnter={() => setActiveDot(1)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(1)}
                  onKeyDown={() => setActiveDot("")}
                  tabindex="0"
              ></div>
              <div
                  id="blobOne"
                  className={classnames(
                      "absolute top-20 left-40 px-12 text-center flex flex-col justify-center items-center rounded-full bg-[#444444] text-white min-w-[443px] h-[443px] transition-all duration-300 ",
                      activeDot === 1
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                  Multimodal Delivery Systems:
                </p>
                <p className="text-xl font-proxima-nova font-thin leading-6">
                  Trucks, used as mobile hubs, dispatch <br />
                  and receive drones responsible for <br />
                  delivery of goods to their final <br />
                  destination along the truck’s route.
                  <br />
                  <br />
                  Last-mile delivery routes for drones are <br />
                  calculated in real-time from the cloud.
                </p>
              </div>
            </div>
            <div></div>
            <div></div>
            <div></div>

            <div></div>
            <div className="relative flex justify-center items-end">
              <div
                  id="dotTwo"
                  className="dot absolute right-1/2 rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] bg-[#444444] border-2 cursor-pointer"
                  onMouseEnter={() => setActiveDot(2)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(2)}
                  onKeyDown={() => setActiveDot("")}
                  tabindex="0"
              ></div>
              <div
                  id="blobTwo"
                  className={classnames(
                      "absolute left-64 top-0 px-12 text-center flex flex-col justify-center items-center rounded-full bg-[#444444] text-white min-w-[443px] h-[443px] transition-all duration-300",
                      activeDot === 2
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                  Truck Monitoring:
                </p>
                <p className="text-xl font-proxima-nova font-thin leading-6">
                  Sensors tracking pallets help <br />
                  provide accurate inventory arrival
                  <br />
                  forecasting, enabling loading bay <br />
                  efficiencies.
                  <br />
                  <br />
                  Temperature sensors for <br />
                  refrigerated items plus blockchain <br />
                  help with maintaining product <br />
                  integrity and traceability.
                </p>
              </div>
            </div>
            <div className="relative flex justify-end pt-20">
              <div
                  id="dotThree"
                  className="dot absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] bg-[#444444] border-2 cursor-pointer"
                  onMouseEnter={() => setActiveDot(3)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(3)}
                  onKeyDown={() => setActiveDot("")}
                  tabindex="0"
              ></div>
            </div>
            <div className="relative flex justify-end">
              <div
                  id="blobThree"
                  className={classnames(
                      "absolute top-0 left-16 2xl:left-32 px-12 text-center flex flex-col justify-center items-center rounded-full bg-[#444444] text-white min-w-[443px] h-[443px] transition-all duration-300 ",
                      activeDot === 3
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                  Robotic Warehouse:
                </p>
                <p className="text-xl font-proxima-nova font-thin leading-6">
                  Inventory and order fulfillment are <br />
                  optimized due to automatic scanning <br />
                  of delivered goods and data uploads <br />
                  to ERP systems.
                  <br />
                  <br />A goods-to-man approach improves <br />
                  worker safety and productivity, which <br />
                  can result in reduced costs and <br />
                  optimized warehouse space.
                </p>
              </div>
            </div>
            <div></div>

            <div className="relative flex justify-center">
              <div
                  id="dotFour"
                  className="dot absolute rounded-full top-8 2xl:top-0 w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] bg-[#444444] border-2 cursor-pointer"
                  onMouseEnter={() => setActiveDot(4)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(4)}
                  onKeyDown={() => setActiveDot("")}
                  tabindex="0"
              ></div>
              <div
                  id="blobFour"
                  className={classnames(
                      "absolute left-[230px] bottom-10 px-8 text-center flex flex-col justify-center items-center rounded-full bg-[#444444] text-white min-w-[331px] h-[331px] transition-all duration-300 ",
                      activeDot === 4
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                  Fleet Management:
                </p>
                <p className="text-xl font-proxima-nova font-thin leading-6">
                  Fuel, oil and vehicle-ware <br />
                  sensors enable predictive
                  <br />
                  maintenance, helping to <br />
                  reduce driver fatigue as well <br />
                  as gain operational <br />
                  efficiencies.
                </p>
              </div>
            </div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </motion.div>
  );
};

export default EdgeLogisitcs;